// extracted by mini-css-extract-plugin
var _1 = "SizeFields_field__a02e9";
var _2 = "SizeFields_fieldLayout__e1526";
var _3 = "SizeFields_group__1d0d4";
var _4 = "SizeFields_label__56a3b";
var _5 = "SizeFields_prefix__b84c2";
export { _1 as "field", _2 as "fieldLayout", _3 as "group", _4 as "label", _5 as "prefix" }
